import { useBindProp as o } from "../props.js";

function t(t, i, e, f) {
  void 0 === e && (e = "show"), void 0 === f && (f = "hide"), o(t, {
    setter: function setter(o, t) {
      t ? "function" == typeof e ? e(o) : o[e]() : "function" == typeof f ? f(o) : o[f]();
    }
  }, i.visible);
}

export default t;